module.exports = __webpack_public_path__ + "static/1-bcfc0b1d563805cc8fc2e5b8d6e83119.jpg";